import { render, staticRenderFns } from "./app-input-select-ps.vue?vue&type=template&id=2fac29f0&scoped=true&"
import script from "./app-input-select-ps.vue?vue&type=script&lang=js&"
export * from "./app-input-select-ps.vue?vue&type=script&lang=js&"
import style0 from "./app-input-select-ps.vue?vue&type=style&index=0&id=2fac29f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fac29f0",
  null
  
)

export default component.exports